module.exports = __webpack_public_path__ + "static/media/LiveMusicPoster.e5590590.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/static/images/LiveMusicPoster.png
// module id = 81
// module chunks = 1